import { WithNavigationWatcher } from "@/iti-core-react/contexts/navigation";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Recycle from "./pages/Recycle/Recycle";

const Dashboard = lazy(() => import("@/pages/Dashboard/Dashboard"));

const CatalogueList = lazy(
	() => import("@/pages/Catalogue/CatalogueList/CatalogueList"),
);
const CatalogueDetail = lazy(
	() => import("@/pages/Catalogue/CatalogueDetail/CatalogueDetail"),
);
const FederatedCatalogueDetail = lazy(
	() =>
		import(
			"@/pages/DataspaceManagement/FederatedCatalogueDetail/FederatedCatalogueDetail"
		),
);
const CatalogueForm = lazy(
	() => import("@/pages/Catalogue/CatalogueForm/CatalogueForm"),
);
const DatabaseConnectionForm = lazy(
	() =>
		import("@/pages/Catalogue/DatabaseConnectionForm/DatabaseConnectionForm"),
);

const GlossaryList = lazy(
	() => import("@/pages/Glossary/GlossaryManagement/GlossaryManagement"),
);
const DataspaceManagement = lazy(
	() => import("@/pages/DataspaceManagement/DataspaceManagement"),
);
const GlossaryDetail = lazy(
	() => import("@/pages/Glossary/GlossaryDetail/GlossaryDetail"),
);
const AutomationCards = lazy(
	() => import("@/pages/Automation/AutomationCards/AutomationCards"),
);
const AutomationDetail = lazy(
	() => import("@/pages/Automation/AutomationDetail/AutomationDetail"),
);
const OrganizationForm = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Organization/OrganizationForm/OrganizationForm"
		),
);
const ExperimentationList = lazy(
	() =>
		import("@/pages/Experimentation/ExperimentationList/ExperimentationList"),
);
const ExperimentationForm = lazy(
	() =>
		import("@/pages/Experimentation/ExperimentationForm/ExperimentationForm"),
);
const ReceivedDatasetShareRequestsList = lazy(
	() =>
		import(
			"@/pages/PermissionsManagement/ReceivedRequestsList/ReceivedRequestsList"
		),
);
const SentDatasetShareRequestsList = lazy(
	() =>
		import("@/pages/PermissionsManagement/SentRequestsList/SentRequestsList"),
);
const CategoryList = lazy(
	() => import("@/pages/Configuration/Category/CategoryList"),
);
const GlobalParametersList = lazy(
	() =>
		import(
			"@/pages/Configuration/GlobalParameters/GlobalParametersList/GlobalParametersList"
		),
);
const OrganizationManagementView = lazy(
	() => import("@/pages/OrganizationManagement/OrganizationManagementView"),
);
const ActivityManagementView = lazy(
	() => import("@/pages/Activity/ActivityManagementView"),
);
const NotificationList = lazy(
	() => import("@/pages/Notification/NotificationList/NotificationList"),
);
const InvitationForm = lazy(() => import("@/pages/Invitation/Invitation"));
const VSCodeViewer = lazy(() => import("@/pages/VSCodeViewer/VSCodeViewer"));

const ProfileForm = lazy(
	() => import("@/pages/Profile/ProfileForm/ProfileForm"),
);
const InvitationProfileList = lazy(
	() => import("@/pages/Profile/InvitationProfileList/InvitationProfileList"),
);
const RoleChangeSentRequestList = lazy(
	() =>
		import("@/pages/Profile/RoleChangeSentRequest/RoleChangeSentRequestList"),
);

const RoleChangeRequestList = lazy(
	() =>
		import(
			"@/pages/OrganizationManagement/RoleChangeRequest/RoleChangeRequestList/RoleChangeRequestList"
		),
);

const SecondStepContainer = lazy(
	() =>
		import(
			"@/pages/Catalogue/CatalogueForm/SecondStep/SecondStepContainer.tsx"
		),
);

const OrganizationList = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Organization/OrganizationList/OrganizationList"
		),
);
const InvitationList = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Invitation/InvitationList/InvitationList"
		),
);
const UserManagementList = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/UserManagement/UserManagementList/UserManagementList"
		),
);

const LegalConditionsManagementTabs = lazy(
	() => import("@/pages/LegalConditions/LegalConditionsManagementTabs"),
);
const LegalConditionsDetail = lazy(
	() =>
		import(
			"@/pages/LegalConditions/LegalConditionManagement/LegalConditionsDetail/LegalConditionsDetail"
		),
);
const Identity = lazy(() => import("@/pages/Identity/Identity"));
const CredentialCreateView = lazy(
	() => import("@/pages/Identity/CredentialCreateView/CredentialCreateView"),
);
const CredentialDetailsView = lazy(
	() => import("@/pages/Identity/CredentialDetailsView/CredentialDetailsView"),
);
const ConnectorsView = lazy(
	() => import("@/pages/MasterManagement/Connectors/ConnectorsView"),
);
const CreateConnectorView = lazy(
	() => import("@/pages/MasterManagement/Connectors/CreateConnectorView"),
);
const UpdateConnectorView = lazy(
	() => import("@/pages/MasterManagement/Connectors/UpdateConnectorView"),
);
const AccessRightsView = lazy(
	() => import("@/pages/MasterManagement/AccessRights/AccessRightsView"),
);
const DetailAccessRightView = lazy(
	() => import("@/pages/MasterManagement/AccessRights/DetailAccessRightView"),
);
const VisualIdentity = lazy(
	() => import("@/pages/WisephereManagement/VisualIdentity/VisualIdentity"),
);

export class RouteDto {
	path: string;
	element: JSX.Element;
	data: {
		isInMenu: boolean;
	};
}

export const routes: RouteDto[] = [
	{
		path: "/legal-conditions",
		element: <LegalConditionsManagementTabs />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/:tab",
		element: <LegalConditionsManagementTabs />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/doc/new",
		element: <LegalConditionsDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/doc/:id/:version?",
		element: <LegalConditionsDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation/:guid",
		element: <InvitationForm />,
		data: { isInMenu: false },
	},
	{
		path: "/dashboard",
		element: <Dashboard />,
		data: { isInMenu: false },
	},
	{
		path: "/user-profile",
		element: <ProfileForm />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation-request",
		element: <InvitationProfileList />,
		data: { isInMenu: false },
	},
	{
		path: "/role-changing",
		element: <RoleChangeSentRequestList />,
		data: { isInMenu: false },
	},
	{
		path: "/role-changing-organization",
		element: <RoleChangeRequestList />,
		data: { isInMenu: false },
	},
	{
		path: "/catalogues",
		element: <CatalogueList />,
		data: { isInMenu: true },
	},
	{
		path: "/catalogue/:id/:tab/*",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations/:automationId/catalogue/:id",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations/:automationId/catalogue/:id/:tab/*",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin/catalogue/:id/:tab",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/federated-catalogue/:datasetId/:tab/:enableImport?",
		element: <FederatedCatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/dataset/:datasetId",
		element: <CatalogueForm />,
		data: { isInMenu: false },
	},
	{
		path: "/dataset/:datasetId/artifact/:artifactId",
		element: <CatalogueForm />,
		data: { isInMenu: false },
	},
	{
		path: "/database-connection/:datasetId",
		element: <DatabaseConnectionForm />,
		data: { isInMenu: false },
	},
	{
		path: "/glossaries",
		element: <GlossaryList />,
		data: { isInMenu: true },
	},
	{
		path: "/glossaries/:id",
		element: <GlossaryDetail />,
		data: { isInMenu: true },
	},
	{
		path: "/dataspaces",
		element: <DataspaceManagement />,
		data: { isInMenu: true },
	},
	{
		path: "recycle-bin/glossaries/:id",
		element: <GlossaryDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations",
		element: <AutomationCards />,
		data: { isInMenu: true },
	},
	{
		path: "/automations/:id/:idDataset?/:backToCatalogue?",
		element: <AutomationDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/organization/:id?",
		element: <OrganizationForm />,
		data: { isInMenu: true },
	},
	{
		path: "recycle-bin/organization/:id?",
		element: <OrganizationForm />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation",
		element: <ExperimentationList />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation/:id",
		element: <ExperimentationForm />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation/VSCodeViewer/:experimentId/:deploymentId",
		element: <VSCodeViewer />,
		data: { isInMenu: false },
	},
	{
		path: "/received-dataset-share",
		element: <ReceivedDatasetShareRequestsList />,
		data: { isInMenu: false },
	},
	{
		path: "/sent-dataset-share",
		element: <SentDatasetShareRequestsList />,
		data: { isInMenu: false },
	},
	{
		path: "/configuration-parameters",
		element: <GlobalParametersList />,
		data: { isInMenu: false },
	},
	{
		path: "/categories",
		element: <CategoryList />,
		data: { isInMenu: false },
	},
	{
		path: "/activity",
		element: <ActivityManagementView />,
		data: { isInMenu: true },
	},
	{
		path: "/notifications",
		element: <NotificationList />,
		data: { isInMenu: true },
	},
	{
		path: "/management/tenant",
		element: <OrganizationManagementView />,
		data: { isInMenu: false },
	},
	{
		path: "/organization-management",
		element: <OrganizationList />,
		data: { isInMenu: false },
	},
	{
		path: "/personalization",
		element: <VisualIdentity />,
		data: { isInMenu: false },
	},
	{
		path: "/usermanagement",
		element: <UserManagementList />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation",
		element: <InvitationList />,
		data: { isInMenu: false },
	},
	{
		path: "/second-step/:datasetId",
		element: <SecondStepContainer />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin",
		element: <Recycle />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin/:tab",
		element: <Recycle />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials",
		element: <Identity />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials/credential/new",
		element: <CredentialCreateView />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials/credential/details/:credentialId",
		element: <CredentialDetailsView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors",
		element: <ConnectorsView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors/new",
		element: <CreateConnectorView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors/edit/:connectorId",
		element: <UpdateConnectorView />,
		data: { isInMenu: false },
	},
	{
		path: "/access_rights",
		element: <AccessRightsView />,
		data: { isInMenu: false },
	},
	{
		path: "/access-rights/detail/:accessRightId",
		element: <DetailAccessRightView />,
		data: { isInMenu: false },
	},
	{
		path: "",
		element: window.self !== window.top ? <CatalogueList /> : <Dashboard />,
		data: { isInMenu: false },
	},
	{
		path: "*",
		element:
			window.self !== window.top ? (
				<Navigate to="/catalogues" />
			) : (
				<Navigate to="/dashboard" />
			),
		data: { isInMenu: false },
	},
];

const wrapNavigationWatcher = (route: RouteDto) => ({
	path: route.path,
	element: (
		<WithNavigationWatcher currentPath={route.path} component={route.element} />
	),
});

export default routes.map(wrapNavigationWatcher);
